import React, { useState } from 'react';
import { navBarBtn } from './BankStatementInsight.module.css';
import NetCashFlow from './NetCashFlow/NetCashFlow';
import Overview from './OverView/Overview';
const BankStatementInsight = ({ url }) => {
  const navBar = [
    {
      key: 'Overview',
      name: 'Overview',
      disabled: false
    },
    {
      key: 'Net Cash flow',
      name: 'Net Cash flow',
      disabled: false
    },
    {
      key: 'Salary',
      name: 'Salary',
      disabled: true
    },
    {
      key: 'Loans',
      name: 'Loans',
      disabled: true
    },
    {
      key: 'Daily Balance',
      name: 'Daily Balance',
      disabled: true
    }
  ];

  const [selectedItem, setSelectedItem] = useState('Overview');

  return (
    <div className="w-full px-2">
      <div className="w-full flex overflow-auto hide-scroll-bar">
        {navBar.map((each, index) => (
          <div
            className={` ${
              selectedItem == each.key
                ? 'bg-green-tePapaGreen text-white'
                : ' bg-green-greenWhite text-black-500'
            } tabel py-2 px-4 text-center items-center text-roboto  ${navBarBtn} `}
            key={index}
            style={{ minWidth: '120px' }}
          >
            <button
              className={`
                ${
                  each?.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                } text-xs
              `}
              disabled={each?.disabled}
              onClick={() => setSelectedItem(each.name)}
            >
              {each.name}
            </button>
          </div>
        ))}
      </div>
      {selectedItem === 'Overview' && <Overview url={url} />}
      {selectedItem === 'Net Cash flow' && <NetCashFlow />}
    </div>
  );
};

export default BankStatementInsight;
